import { fetchProductSubscription } from 'actions/LuxPlusActions'
import { useAppDispatch } from 'hooks/reduxHooks'
import { useEffect } from 'react'

export default function useLuxPlusSubscriptionProduct(enabled: boolean = true) {
  const dispatch = useAppDispatch()

  useEffect(() => {
    if (enabled) {
      dispatch(fetchProductSubscription())
    }
  }, [dispatch, enabled])
}
